import { render, staticRenderFns } from "./StarshopMarketingDashboard.vue?vue&type=template&id=8861dfe2"
import script from "./StarshopMarketingDashboard.vue?vue&type=script&lang=js"
export * from "./StarshopMarketingDashboard.vue?vue&type=script&lang=js"
import style0 from "./StarshopMarketingDashboard.vue?vue&type=style&index=0&id=8861dfe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports